import { styled } from '@mui/material/styles';
import { compose } from 'utils/compose';
import { inject, observer } from 'mobx-react';
import { Button } from '@mui/material';

import useSearchParams from 'hooks/useSearchParams';
import { QUESTIONNAIRE_PROPERTIES } from 'constants/common';

const PREFIX = 'QuestionnaireButton';

const classes = {
  root: `${PREFIX}-root`,
  btn: `${PREFIX}-btn`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '1rem 0',
  },

  [`& .${classes.btn}`]: {
    color: theme.colorTokens.hyperlink,
    textDecoration: 'underline',
    textUnderlineOffset: '0.2rem',
    textTransform: 'inherit',

    '&:hover': {
      textDecoration: 'underline',
      backgroundColor: 'transparent',
    },
  },
}));

function AddressQuestionnaireButton({ store }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const { deliveryStore } = store;
  const { delivery } = deliveryStore;
  const data = delivery?.['recipient-questionnaire'];
  const doing = typeof data === 'object' && QUESTIONNAIRE_PROPERTIES.some((property) => data.hasOwnProperty(property));
  const option = searchParams.get('skip_questionnaire');

  const handleSkipQuestionnaire = () => {
    if (option === 'skipped') searchParams.set('skip_questionnaire', 'doing');
    if (option === 'skippable') searchParams.set('skip_questionnaire', 'skipped');

    setSearchParams(searchParams);
  };

  if (doing || !option) return null;

  return (
    <Root className={classes.root}>
      <Button className={classes.btn} variant="text" color="primary" size="small" onClick={handleSkipQuestionnaire}>
        {option === 'skipped' && 'Take Questionnaire'}
        {option === 'skippable' && 'Do Questionnaire Later'}
      </Button>
    </Root>
  );
}

export default compose(inject('store'), observer)(AddressQuestionnaireButton);
